// Phase 31.1 Plan 04 — UAT Gap 6b (2026-04-20): Front Garden subAreas expanded
// to match Back Garden's 6 presets so the onboarding sub-spaces step offers the
// same recommendations for both. Existing users pick up the new presets via the
// DATA_VERSION migration (step 5 — merge new sub-areas into stored areas).
export const INITIAL_AREAS = [
  {id:"a1",name:"Back Garden",subAreas:["Main Border","Shady Border","Pots & Containers","Lawn Edge","Lawn","Wall / Fence"]},
  {id:"a2",name:"Front Garden",subAreas:["Main Border","Shady Border","Pots & Containers","Lawn Edge","Lawn","Wall / Fence"]},
];
